export const DEBOUNCE_DELAY = 500;

export default {};
